/**
 * Verified client testimonials. These are real, attributable reviews — never
 * add anything here that a client has not actually given us.
 */
export interface Testimonial {
  quote: string;
  name: string;
  role: string;
  /** Rough location, used to surface the most relevant quote on area pages. */
  area?: string;
}

export const testimonials: Testimonial[] = [
  {
    quote:
      "Jordan and his team are outstanding. Having him work with our organisation is amazing. He has an incredible depth of knowledge and immediately spots things we might have missed; he is completely professional whilst still being approachable, and that hasn't been our experience of accountants in the past. Jordan works quickly, without fuss, and delivers a first class service. We are grateful to have found him.",
    name: "E Brown",
    role: "EveryDoctor Ltd",
  },
  {
    quote:
      "Jordan and Lorraine provide a very personalised service. They have helped me to develop my business and help me understand the process every step of the way. I could not have done it without them and thoroughly recommend their services.",
    name: "N Collings",
    role: "Forest 1st Tutoring Limited",
    area: "new-forest",
  },
  {
    quote:
      "Down to earth, really helpful accountant; exactly what we needed for our butchery and farm shop. They're easy to deal with, quick to respond, and they make everything feel clear and manageable. Highly recommended.",
    name: "The Farmers Butcher",
    role: "Butchery & Farm Shop",
    area: "salisbury",
  },
];

/**
 * schema.org Review nodes for a LocalBusiness block.
 *
 * Deliberately omits reviewRating and aggregateRating — we hold the written
 * testimonials but not verified star ratings, and inventing them would be
 * both false and a structured-data violation.
 */
export function reviewSchema(businessName: string) {
  return testimonials.map((t) => ({
    "@type": "Review",
    author: { "@type": "Person", name: t.name },
    reviewBody: t.quote,
    itemReviewed: { "@type": "AccountingService", name: businessName },
  }));
}
